import React, { useState } from 'react';
import { StepContainer, StepNavigation, FormFieldGroup } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20B_MotivacaoEmbaixadora: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
    const { data, updateField } = useFormContext();
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleNext = () => {
        const newErrors: Record<string, string> = {};

        if (!data.salesMotivation) newErrors.salesMotivation = 'Este campo é obrigatório';
        if (!data.ambassadorReason) newErrors.ambassadorReason = 'Este campo é obrigatório';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        onNext({
            salesMotivation: data.salesMotivation,
            ambassadorReason: data.ambassadorReason
        });
    };

    const handleFieldChange = (field: string, value: string) => {
        updateField(field as any, value);
        if (errors[field]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[field];
                return newErrors;
            });
        }
    };

    return (
        <StepContainer title="">
            <div className="space-y-6">
                <p className='mb-0'>Qual seu principal objetivo ou quais desejos/sonhos quer realizar ao buscar renda através da revenda de semijoias?</p>
                
                <FormFieldGroup
                    label="Seu objetivo:"
                    required
                    error={errors.salesMotivation}
                >
                    <textarea
                        value={data.salesMotivation || ''}
                        onChange={(e) => handleFieldChange('salesMotivation', e.target.value)}
                        rows={3}
                        placeholder="Preencha aqui..."
                        className="form-textarea"
                    />
                </FormFieldGroup>
                <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-0">
                    <p className="text-amber-900 text-sm mb-0">
                        <span className="font-semibold">⚠️ Atenção:</span> RENDA EXTRA NÃO É OBJETIVO.
                    </p>
                </div>

                <FormFieldGroup
                    label="Por que você acredita que a X do Infinito deveria selecionar você como Embaixadora para revender os produtos da marca?"
                    required
                    error={errors.ambassadorReason}
                >
                    <textarea
                        value={data.ambassadorReason || ''}
                        onChange={(e) => handleFieldChange('ambassadorReason', e.target.value)}
                        rows={3}
                        placeholder="Preencha aqui..."
                        className="form-textarea"
                    />
                </FormFieldGroup>
            </div>

            <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
        </StepContainer>
    );
};

export default Step20B_MotivacaoEmbaixadora;
